export default __webpack_public_path__ + "static/media/Crossing-Blue-24x24.e619ba86.svg";